import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import CasterContent from "./CasterPumpContent";

class SupplierDetails extends React.Component {
  render() {
    return (
      <div className="col-lg-8 col-md-12">
        <Switch>
          <Route path="/suppliers/caster" component={CasterContent} />
          <Route path="/suppliers/caster">
            <Redirect to="/suppliers/caster/pumps" />
          </Route>
        </Switch>
      </div>
    );
  }
}

export default SupplierDetails;
